import React from 'react';
import { InsightSection } from 'store/state/insightsContext';
import WidgetWrapper from 'components/widget/common/widget-wrapper';
import { InsightType } from 'utils/entities';
import { useLocale } from 'locale';
import { DetailPageEventCategory } from 'analytics/handlers/detailPageSectionHandlers';
import { useTheme } from 'hooks/useTheme';
import CarouselStories from 'components/view-pager-to-stories';
import { IInsightPreview } from 'components/widget/common/styled';
import WidgetCollapsedWrapper from '../../common/widget-collapsed-wrapper';
import { useCheckProjectPage } from 'hooks/useCheckProjectPage';

interface SafetyWidgetProps {
  eventCategory: DetailPageEventCategory;
  onReadMoreCarouselClick: (id: string) => void;
  carouselData: IInsightPreview[];
  carouselIdx: number;
  setActiveCarouselIdx: (index: number) => void;
  isCollapsed: boolean;
  showCarousel: boolean;
}

const SafetyWidget: React.FC<SafetyWidgetProps> = ({
  carouselData,
  carouselIdx,
  onReadMoreCarouselClick,
  setActiveCarouselIdx,
  showCarousel,
  isCollapsed,
}) => {
  const { t } = useLocale();
  const { colors } = useTheme();
  const widgetHasCarouselData = showCarousel && carouselData && carouselData.length;
  const isProjectPage = useCheckProjectPage();

  if (!widgetHasCarouselData && !isCollapsed && !isProjectPage) {
    return null;
  }

  const carousel = (
    <CarouselStories
      insights={carouselData}
      onReadMoreClick={onReadMoreCarouselClick}
      slideIndex={carouselIdx}
      onSlideIndexChange={(idx) => setActiveCarouselIdx(idx)}
      color={colors.insights.safety}
    />
  );

  const wrapperProps = {
    carousel: widgetHasCarouselData ? carousel : null,
    targetId: InsightSection.Safety,
    styleType: InsightType.Safety,
    title: t('widgetTitle.safety'),
  };

  return isCollapsed
    ? <WidgetCollapsedWrapper {...wrapperProps} />
    : <WidgetWrapper {...wrapperProps} />;
};

export default SafetyWidget;
